import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./polifill";
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './app/store'
import { Provider } from 'react-redux'
import SuspenseContent from './containers/SuspenseContent';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { StyleProvider } from '@ant-design/cssinjs';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <TonConnectUIProvider manifestUrl="https://secure-dashboard-xyz789.webtransfer.app/tonconnect-manifest.json">
    <Suspense fallback={<SuspenseContent />}>
      <StyleProvider hashPriority="high">
        <Provider store={store}>
          <App />
        </Provider>
      </StyleProvider>
    </Suspense>
  </TonConnectUIProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
